import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {Server} from "../model/server.model";

export enum ModelType {
	ROUTER = "Router"
}

export interface ModelClick {
	id: string;
	type: string;
}

@Injectable({
  providedIn: 'root'
})
export class InfrastructureSchemasInteractionService {

  constructor() { }

	private subject: Subject<ModelClick> = new Subject();

	click$ = this.subject.asObservable();

  	click(id: string, type: string) {
		  this.subject.next({id, type});
	}
}

export class InfrastructureSchemasInteractionServerService {

	constructor() { }

	private subject: Subject<Server[]> = new Subject();

	click$ = this.subject.asObservable();

	click(server: Server[]) {
		this.subject.next(server);
	}
}
